module.exports = __webpack_public_path__ + "img/business-loan.fd3e7a12.svg";